import React from 'react'

const Loading = () => {
    return (
        <div id="genloading">
            <div>
                <i className="far fa-clock fa-spin"></i>
            </div>
        </div>
    )
}

export default Loading
